import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  TextInput,
  Button,
  Checkbox,
} from 'flowbite-react';
import ReactSelect from 'react-select';


const customStyles = {
  control: (base, state) => ({
    ...base,
    // remove the default focus box-shadow:
    boxShadow: 'none',
    // keep the same border color whether focused or not:
    borderColor: state.isFocused ? '#ccc' : '#ccc',
    // optional: lighten the hover state too
    '&:hover': {
      borderColor: '#bbb',
    },
  }),
  // remove any outline on the input itself:
  input: (base) => ({
    ...base,
    outline: 'none',
  }),
};

const typeOptions = [
  { value: 'Company', label: 'Company' },
  { value: 'Commodity', label: 'Commodity' },
  { value: 'User', label: 'User' },
  { value: 'Application', label: 'Application' },
  { value: 'Cancellation', label: 'Cancellation' },
  { value: 'Carrier', label: 'Carrier' },
  { value: 'Driver', label: 'Driver' },
  { value: 'Endorsement', label: 'Endorsement' },
  { value: 'Loss', label: 'Loss' },
  { value: 'Policy', label: 'Policy' },
  { value: 'ProducerForm', label: 'Producer Form' },
  { value: 'Quote', label: 'Quote' },
  { value: 'SafetyScore', label: 'Safety Score' },
  { value: 'Vehicle', label: 'Vehicle' },
  { value: 'PriorPolicy', label: 'Prior Policy' }
];

/**
 * Props:
 * - isOpen
 * - onClose
 * - newFieldName, setNewFieldName
 * - newFieldType, setNewFieldType
 * - isList, setIsList
 * - onAddField
 */
export default function AddRequestFieldModal({
  isOpen,
  onClose,
  newFieldName,
  setNewFieldName,
  newFieldType,
  setNewFieldType,
  isList,
  setIsList,
  fieldLabel,
  setFieldLabel,
  onAddField,
}) {
  // label switches based on list vs single
  const typeLabel = isList ? 'Element Type' : 'Type';

  function handleAdd() {
    // if isList, send { type: 'array', items: newFieldType }
    if (!newFieldName || !newFieldType) {
      alert("Please provide both a name and type.");
      return;
    }
    onAddField({
      name: newFieldName,
      type: isList ? 'array' : newFieldType,
      label: fieldLabel,
      ...(isList ? { items: newFieldType } : {}),
    });
  }

  return (
    <Modal size="xl" show={isOpen} onClose={onClose}>
      <ModalHeader>Add Request Field</ModalHeader>
      <ModalBody>
        <div className="space-y-4">
          {/* Name */}
          <div>
            <Label htmlFor="field-name">Name</Label>
            <TextInput
              id="field-name"
              value={newFieldName}
              onChange={e => setNewFieldName(e.target.value.replace(/\s/g, ''))}
              placeholder="e.g. userId"
            />
          </div>

          {/* Type or Element Type */}
          <div>
            <Label htmlFor="field-type">{typeLabel}</Label>
            <ReactSelect
              inputId="field-type"
              options={typeOptions}
              styles={customStyles}
              value={typeOptions.find(opt => opt.value === newFieldType) || null}
              onChange={opt => {
                setFieldLabel(opt.label);
                setNewFieldType(opt.value);
              }}
              isSearchable
              placeholder={`Select ${typeLabel.toLowerCase()}…`}
              classNamePrefix="field-type"
            />
          </div>

          
          {/* Is List? */}
          <div className="flex items-center gap-2">
            <Checkbox
              id="field-is-list"
              checked={isList}
              onChange={e => setIsList(e.target.checked)}
              label="Is this a list (array)?"
            />
            <Label htmlFor="field-is-list">Is this a list (array)?</Label>
          </div>
        </div>
      </ModalBody>

      <ModalFooter>
        <Button color="blue" onClick={handleAdd}>
          Add
        </Button>
        <Button color="light" onClick={onClose}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}
